import React, { useRef, useEffect } from 'react';
import carouselData from './carouselData.json';
import './Resources.css';

const Resources = () => {
	const trackRef = useRef(null);
	let autoScrollInterval = useRef(null);

	const handleScroll = (direction) => {
		
		const cardWidth = trackRef.current.querySelector('.carouselCard').offsetWidth;
		const gapWidth = 20; 
		const scrollAmount = cardWidth + gapWidth;
		
		if (direction === 'left') {
			trackRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
		} else if (direction === 'right') {
			trackRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		}
	};

	const startAutoScroll = () => {
		autoScrollInterval.current = setInterval(() => {
			handleScroll('right');
		}, 3000); 
	};

	const stopAutoScroll = () => {
		clearInterval(autoScrollInterval.current);
	};

	const resetScroll = () => {
		
		if (trackRef.current.scrollLeft + trackRef.current.clientWidth >= trackRef.current.scrollWidth) {
			trackRef.current.scrollLeft = 0; 
		}
	};
	
	useEffect(() => {
		startAutoScroll();
		return () => stopAutoScroll();
	}, []);

	return (
		<div className="sparePartsContainer" id="resources">
			<h2 className="sparePartsTitle">Resources for Robotics</h2>
			<div
				className="carouselContainer"
				onMouseEnter={stopAutoScroll} 
				onMouseLeave={startAutoScroll} 
			>
				<button className="carouselButton left" onClick={() => handleScroll('left')}>
					‹
				</button>

				<div
					className="carouselTrack"
					ref={trackRef}
					onScroll={resetScroll} 
				>
					{carouselData.map((item, index) => (
						<div key={index} className="carouselCard">
							<img
								src={process.env.PUBLIC_URL + item.imageUrl}
								alt={item.title}
								className="carouselImage"
							/>
							<h3 className="carouselTitle">{item.title}</h3>
							<p className="carouselDescription">{item.description}</p>
						</div>
					))}
				</div>

				<button className="carouselButton right" onClick={() => handleScroll('right')}>
					›
				</button>
			</div>
		</div>
	);
};

export default Resources;
